export const JOIN_GAME_REQUEST = "JOIN_GAME_REQUEST";
export const JOIN_GAME_REQUEST_SUCCESS = "JOIN_GAME_REQUEST_SUCCESS";
export const JOIN_GAME_REQUEST_ERROR = "JOIN_GAME_REQUEST_ERROR";
export const GAME_EXIT_REQUEST = "GAME_EXIT_REQUEST";
export const GAME_DASHBOARD_CARD_CREATE_REQUEST = "GAME_DASHBOARD_CARD_CREATE_REQUEST";
export const GAME_DASHBOARD_CARD_CREATE_REQUEST_SUCCESS = "GAME_DASHBOARD_CARD_CREATE_REQUEST_SUCCESS";
export const GAME_DASHBOARD_CARD_CREATE_REQUEST_ERROR = "GAME_DASHBOARD_CARD_CREATE_REQUEST_ERROR";
export const UPDATE_ACTIVE_OVERLAY_ID = "UPDATE_ACTIVE_OVERLAY_ID";
export const UPDATE_OPEN_SITUATION_ID = "UPDATE_OPEN_SITUATION_ID";
export const SHOWBLUR_IMAGE = "SHOWBLUR_IMAGE";
export const UPDATE_OPEN_SITUATION_ARRAY = "UPDATE_OPEN_SITUATION_ARRAY";


